module.exports={render:function (){with(this) {
  return _h('div', {
    class: ("game " + (hover && !found && !expertMode ? 'hover' : '')),
    on: {
      "mousemove": onMouseMove,
      "touchmove": onMouseMove,
      "click": onClick
    }
  }, [(found) ? _h('find-animal', {
    attrs: {
      "animal": animal,
      "initialX": x,
      "initialY": y
    },
    on: {
      "complete": onAnimalComplete
    }
  }) : _e()])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-db981146!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game.vue
 ** module id = 170
 ** module chunks = 2
 **/